<template>
  <button
    :class="['cf-header__cart-button', { 'cf-header__cart-button--alternate': isTableTopDeviceOrdering }]"
    type="button"
    title="View Cart"
    :disabled="isDisabled"
    @click="cartClickHandler"
  >
    <div
      v-if="isNotReadOnlyMenu"
      class="cart-button-icon"
    >
      <span class="cf-icon far fa-shopping-bag" />

      <transition name="cart-icon">
        <span
          v-if="order.orderItemStagedCount > 0"
          :key="order.orderItemStagedCount"
          class="cart-count cart-count--order-at-table"
        >
          {{ order.orderItemStagedCount }}
        </span>
      </transition>
    </div>

    <template v-if="isTableTopDeviceOrdering">
      {{ cartCtaContent }}
    </template>
  </button>
</template>


<script>
  import { mapGetters } from 'vuex';

  import { goToOrderAtTableCart } from '@/services/navigation/go-to-order-at-table-cart';


  export default {
    name: 'CfOrderAtTableCartButton',

    computed: {
      ...mapGetters('merchant', ['loyaltyOptions', 'merchant']),
      ...mapGetters('orders', ['order', 'orderItemCountForUser', 'upsellItems']),
      ...mapGetters('session', ['currentUser', 'orderDetails', 'session', 'isTableTopDeviceOrdering']),
      ...mapGetters('locations', ['selectedLocation']),

      isNotReadOnlyMenu() {
        return !this.merchant.features['readonly-order-at-table'];
      },

      cartCtaContent() {
        return this.isNotReadOnlyMenu ? 'View Cart' : 'View Bill';
      },

      isDisabled() {
        if (this.isNotReadOnlyMenu) {
          return this.order.orderItemsStaged.length === 0 && this.order.orderItemCount === 0;
        }

        return false;
      }
    },

    methods: {
      cartClickHandler() {
        goToOrderAtTableCart();
      }
    }
  };
</script>
